<template>
  <header>
    <AppTitle>угадывай тексты</AppTitle>
    <AppTitle>песен и выигрывай</AppTitle>
    <AppTitle>призы от Мегафона</AppTitle>
  </header>
</template>


<script>
import AppTitle from './AppTitle';

export default {
  name: 'ProductDescription',

  components: {
    AppTitle,
  },
};
</script>


<style lang="scss" scoped>
header {
  width: var(--max-width);
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 60px;
  gap: 4px;
  width: 100%;

  :deep(h1) {
    margin-left: auto;
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    gap: 16px;
  }
}
</style>